module.exports = __webpack_public_path__ + "media/slot-game/baget-2093531b.svg";